import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import InfoEditCard from "../../components/Cards/InfoEditCard";
import InfoAddCard from "../../components/Cards/InfoAddCard";
import { FaGraduationCap, FaUserTie } from "react-icons/fa";
import { PiBagFill } from "react-icons/pi";
import { HiLightBulb } from "react-icons/hi";
import { MdClear } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import axiosInstance from "../../services/api/axiosInstance";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import images from "../../utils/images";
import toast from 'react-hot-toast';
import CandidateProfile from './CandidateProfile';
import InputGroup from 'components/Input/InputGroup';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { FiInfo } from 'react-icons/fi';
import { formatNumber } from 'ReusableFunctions/convertShowingResults';

const InvitedApplicants = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const applicants_job_id = queryParams.get("applicants_job");

    const pageRender = useNavigate();
    const [mobileScreen, setMobileScreen] = useState(window.innerWidth)
    const [invitedApplicantsData, setnvitedApplicantsData] = useState({})
    const [invitedApplicants, setnvitedApplicants] = useState([])
    const [invitedApplicantsNonEditable, setnvitedApplicantsNonEditable] = useState([])
    const [pageContentLoaded, setPageContentLoaded] = useState(false)
    const [professionalId, setProfessionalId] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [isSearchedOnce, setIsSearchedOnce] = useState(false);
    const [poolSearch, setPoolSearch] = useState("");
    const [invitedApplicantsStatus, setInvitedApplicantsStatus] = useState("All")
    const invitedApplicantsStatusArray = ["All", "Invited from Best fit", "Invited from pool page"]
    const [sendInviteData, setSendInviteData] = useState({
        professional_id: '',
        job_id: '',
        employer_feedback: '',
        job_title: ''
    })

    useEffect(() => {
        fetchData()
    }, []);

    useEffect(() => {
        let filteredData = []
        if (invitedApplicantsStatus !== "All") {
            filteredData = invitedApplicantsNonEditable?.filter((value) => {
                if (value?.invited_mode === "from pool page" && invitedApplicantsStatus === "Invited from pool page") {
                    return value
                }

                if (value?.invited_mode !== "from pool page" && invitedApplicantsStatus === "Invited from Best fit") {
                    return value
                }
            })
        } else {
            filteredData = invitedApplicantsNonEditable
        }
        setnvitedApplicants(filteredData)

    }, [invitedApplicantsStatus])


    const fetchData = async () => {
        try {
            setPageContentLoaded(false)
            const { data } = await axiosInstance.post("/invited_applicants_view", { job_id: parseInt(applicants_job_id) });
            if (data?.error_code === 0) {
                setnvitedApplicants(data?.data?.final_result)
                setnvitedApplicantsNonEditable(data?.data?.final_result)
                setnvitedApplicantsData(data?.data)

                setSendInviteData({
                    employer_feedback: '',
                    job_id: applicants_job_id,
                    professional_id: '',
                    job_title: data?.data?.job_title || ''
                })
                setPageContentLoaded(true)

            } else {
                toast.error(data?.message);
                setPageContentLoaded(false)
            }
        } catch (err) {
            toast.error(err.message);
            setPageContentLoaded(false)
        }
    };

    // Function to handle scroll event
    const handleScroll = () => {
        if (window.pageYOffset > 200) {
            // Adjust this value according to your needs
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Function to scroll to the top of the page
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Optional: smooth scrolling animation
        });
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);
    const handleResize = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 588) {
            setMobileScreen(screenWidth);
        } else {
            setMobileScreen(null);
        }
    };

    useEffect(() => {
        handleResize();

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleViewFullProfile = async (professionalId) => {
        setProfessionalId(professionalId);
    };

    const handlePoolSearch = (e) => {
        if (!isSearched) {
            setIsSearched(true);
        }
        setPoolSearch(e.target.value);
    };

    //search endpoint
    const handleSearchData = async (id, from_mail) => {
        setPageContentLoaded(false);
        setInvitedApplicantsStatus("All")

        if (!isSearchedOnce || id === 0) {
            setnvitedApplicants([]);
            setnvitedApplicantsData({});
            setIsSearchedOnce(true);
        }

        try {
            const obj = {
                job_id: applicants_job_id,
                search_text: poolSearch.trim(),
                search_req_from: ""
            };

            const { data } = await axiosInstance.post("/invited_applicants_search", obj);
            if (data.error_code === 200) {

                setPageContentLoaded(true)
                setnvitedApplicants(data?.data?.final_result)
                setnvitedApplicantsNonEditable(data?.data?.final_result)
                setnvitedApplicantsData(data?.data)
            } else {
                setPageContentLoaded(false);
            }
        } catch (Err) {
            console.log(Err);
        }
    };

    //search input enter key down
    const handlekeydown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (poolSearch) {
                setIsSearched(true);
                handleSearchData(0);
            } else {
                toast.error("search field is empty");
            }
        }
    };

    //clear search
    const handleClearSearch = () => {
        setPoolSearch("");
        setIsSearchedOnce(false);

        if (isSearched) {
            setPageContentLoaded(false);
            setIsSearched(false);
            fetchData();
        }
    };

    return (
        <div className="homePage-backgroundColor overflow-hidden">
            <div className="container-fluid h-100">
                <div className="d-flex flex-wrap pt-3 align-items-center">
                    <div className="col-12 col-lg-7 py-2 py-md-0">
                        <button
                            className="btn btn-transparent d-flex align-items-center gap-2"
                            onClick={() => {
                                pageRender("/employer_dashboard/candidates");
                            }}
                        >
                            <FaArrowLeftLong className="fs-5" /> Invited Applicants
                        </button>
                    </div>


                    <div className="col-12 col-lg-5 mb-lg-2">
                        {
                            sendInviteData?.job_title ?
                                <p className='w-100 mb-0'>
                                    <strong>Job Title : </strong>
                                    {sendInviteData?.job_title}
                                </p>
                                :
                                null
                        }
                    </div>

                    <div className="col-12 col-lg-7">
                        <p className='px-3 pt-3 mb-0 text-secondary fs-14'>
                            <strong>Showing : </strong>
                            {formatNumber(invitedApplicants?.length)} results
                        </p>
                    </div>

                    <div className={pageContentLoaded || poolSearch ? "col-12 col-lg-5 d-flex flex-wrap" : "d-none"} id="searchInputField">
                        <div className="col-4 pe-2">
                            <div className="dropdown employer-custom-dropdown">
                                <button
                                    id="applicantsStatusButton"
                                    className="btn dropdown-toggle w-100 filter-section d-flex flex-wrap align-items-center choose-dropdown"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    disabled={!pageContentLoaded}
                                >
                                    <span className="fw-bold">Filter</span>
                                    <span className="text-secondary ps-3">
                                        {invitedApplicantsStatus}
                                    </span>
                                </button>

                                <ul className={`dropdown-menu w-100 border-0 shadow ${!pageContentLoaded ? 'pe-none dropdown-box-disable' : ''}`}>
                                    {
                                        invitedApplicantsStatusArray.map((v, i) => {
                                            return <li key={i}>
                                                <a className={`dropdown-item dropdown-jobSort ${!pageContentLoaded ? 'pe-none dropdown-List-disable' : ''}`}
                                                    onClick={() => setInvitedApplicantsStatus(v)}
                                                >
                                                    {invitedApplicantsStatusArray[i]}
                                                </a>
                                            </li>
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className="d-flex position-relative col-8" >
                            <InputGroup
                                className="home-search-icon fs-5"
                                reIcons={<IoIosSearch />}
                            />

                            <input
                                type="text"
                                className="form-control form-control-lg searchInput candidate-searchInput border-0 px-5 py-0 searchInput-border"
                                placeholder="Search by user id, skill, experience, education"
                                aria-label="default input example"
                                value={poolSearch}
                                onChange={(e) => handlePoolSearch(e)}
                                onKeyDown={handlekeydown}
                            />

                            {isSearched ? (
                                <div
                                    className="searchButtonClick-superAdmin "
                                    title="Search"
                                    onClick={() => handleSearchData(0)}
                                >
                                    <IoIosSearch />
                                </div>
                            ) : null}

                            <div
                                className="clearButtonClick-superAdmin"
                                title="Clear"
                                onClick={handleClearSearch}
                            >
                                <MdClear />
                            </div>
                        </div>
                    </div>
                </div>


                {!pageContentLoaded ?
                    <>
                        <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="card mt-3 border-0 shadow-sm rounded-4">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between ms-1">
                                                <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                    <HiLightBulb
                                                        className={
                                                            pageContentLoaded
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-3 placeholder rounded-2"
                                                        }
                                                    />
                                                    <span
                                                        className={
                                                            pageContentLoaded
                                                                ? ""
                                                                : "placeholder px-3 w-100 py-1  rounded-1"
                                                        }
                                                    >
                                                        Skills
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                    <p
                                                        className={
                                                            pageContentLoaded
                                                                ? "mt-0 word-space-content px-0 ms-1"
                                                                : "placeholder px-3 py-2 mt-0 rounded-1"
                                                        }
                                                    >
                                                        Your skills will be displayed here
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                            </div>

                            <div className="mt-4 text-end">
                                <button
                                    className={
                                        pageContentLoaded
                                            ? "btn btn-brand-color"
                                            : "btn  placeholder rounded-2"
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#fullProfileModal"
                                >
                                    Click here to see full profile
                                </button>
                            </div>
                        </div>
                        <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="card mt-3 border-0 shadow-sm  rounded-4">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between ms-1">
                                                <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                    <HiLightBulb
                                                        className={
                                                            pageContentLoaded
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-3 placeholder rounded-2"
                                                        }
                                                    />
                                                    <span
                                                        className={
                                                            pageContentLoaded
                                                                ? ""
                                                                : "placeholder px-3 w-100 py-1  rounded-1"
                                                        }
                                                    >
                                                        Skills
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                    <p
                                                        className={
                                                            pageContentLoaded
                                                                ? "mt-0 word-space-content px-0 ms-1"
                                                                : "placeholder px-3 py-2 mt-0 rounded-1"
                                                        }
                                                    >
                                                        Your skills will be displayed here
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                            </div>

                            <div className="mt-4 text-end">
                                <button
                                    className={
                                        pageContentLoaded
                                            ? "btn btn-brand-color"
                                            : "btn  placeholder rounded-2"
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#fullProfileModal"
                                >
                                    Click here to see full profile
                                </button>
                            </div>
                        </div>
                    </>
                    :
                    invitedApplicants?.length > 0 ?
                        invitedApplicants?.map((value, i) => {
                            return (
                                <React.Fragment key={value?.id}>
                                    {value?.about?.length === 0 &&
                                        value?.experience?.length === 0 &&
                                        value?.skills?.length === 0 &&
                                        value?.education?.length === 0 ? null : (
                                        <div
                                            className={`card  border-0 shadow-sm ${mobileScreen ? "px-3" : "px-5"
                                                } py-3 my-4 placeholder-glow h-100`}
                                        >
                                            <div className="row" id={i === 0 ? "firstCard" : ""}>
                                                <div className="card-header bg-transparent d-flex justify-content-between align-items-center">
                                                    <p className={pageContentLoaded ?
                                                        "mb-1"
                                                        :
                                                        "placeholder py-2 rounded-2"
                                                    }>
                                                        USER ID :{" "}
                                                        <strong>{value?.professional_id}</strong>

                                                        <span className={`ms-3 ${value?.invited_mode === 'from pool page' || value?.invited_mode === null ? 'invite_from_pool_page' : 'invite_from_best_fit'}`}>
                                                            Invited {value?.invited_mode === 'from pool page' || value?.invited_mode === null ? 'from pool page' : 'from best fit applicants'}
                                                        </span>
                                                    </p>



                                                    <div className={` ${mobileScreen ? "text-center" : "text-end"}`} id={`viewFullProfile${value?.id}Button`} >
                                                        <button id={`${i === 0 ? "clickToSeeProfile2" : ""}`}
                                                            className={pageContentLoaded ? `btn border-brand-color py-1` : "btn btn-sm placeholder rounded-2"}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#fullProfileModal"
                                                            onClick={() =>
                                                                handleViewFullProfile(value?.professional_id)
                                                            }>
                                                            View full profile
                                                        </button>
                                                    </div>
                                                </div>
                                                {value.about.length === 0 ? null : (
                                                    <div className="col-lg-6 col-md-12 ">
                                                        <InfoEditCard
                                                            pageContentLoaded={pageContentLoaded}
                                                            cardHeadingIcon={
                                                                <FaUserTie
                                                                    className={pageContentLoaded ? "me-4 brand-color fs-4"
                                                                        : "me-4  fs-4 placeholder rounded-2"
                                                                    } />
                                                            }
                                                            cardHeading="About"
                                                            id="pageTop"
                                                            placeholder="Provide a brief description about yourself"
                                                            cardContent={value?.about?.length > 200 ?
                                                                `${value?.about?.slice(0, 250)}..`
                                                                : `${value?.about}`
                                                            }
                                                            mobileScreen={mobileScreen}
                                                        />
                                                    </div>
                                                )}

                                                {value?.experience?.length === 0 ? null : (
                                                    <div className="col-lg-6 col-md-12">
                                                        <InfoAddCard
                                                            pageContentLoaded={pageContentLoaded}
                                                            cardHeadingIcon={
                                                                <PiBagFill
                                                                    className={
                                                                        pageContentLoaded
                                                                            ? "me-4 brand-color fs-4"
                                                                            : "me-4  fs-4 placeholder rounded-2"
                                                                    }
                                                                />
                                                            }
                                                            cardHeading="Experience"
                                                            placeholder="Your experience details will be displayed here"
                                                            arrayContent={value?.experience[0]}
                                                            currentPage="employerPool"
                                                            mobileScreen={mobileScreen}
                                                        />
                                                    </div>
                                                )}
                                                {value?.skills?.length === 0 ? null : (
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="card mt-3 border-0 rounded-4">
                                                            <div
                                                                className={`card-body ${mobileScreen ? "px-0 py-0" : ""
                                                                    }`}
                                                            >
                                                                <div className="d-flex justify-content-between ms-1">
                                                                    <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                                        <HiLightBulb
                                                                            className={
                                                                                pageContentLoaded
                                                                                    ? "me-4 brand-color fs-4"
                                                                                    : "me-4  fs-3 placeholder rounded-2"
                                                                            }
                                                                        />
                                                                        <span
                                                                            className={
                                                                                pageContentLoaded
                                                                                    ? ""
                                                                                    : "placeholder px-3 w-100 py-1  rounded-1"
                                                                            }
                                                                        >
                                                                            Skills
                                                                        </span>
                                                                    </label>
                                                                </div>

                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                                        {value?.skills?.length === 0 ? (
                                                                            <p
                                                                                className={
                                                                                    pageContentLoaded
                                                                                        ? "mt-0 word-space-content px-0 ms-1"
                                                                                        : "placeholder px-3 py-2 mt-0 rounded-1"
                                                                                }
                                                                            >
                                                                                Your skills will be displayed here
                                                                            </p>
                                                                        ) : (
                                                                            value?.skills
                                                                                .slice(0, 5)
                                                                                .map((skill, id) => {
                                                                                    return (
                                                                                        <React.Fragment key={skill?.id}>
                                                                                            <div className="col mt-0  px-0 me-2">
                                                                                                <div
                                                                                                    className={
                                                                                                        pageContentLoaded
                                                                                                            ? "border rounded-2 p-2 fw-bold mb-3 "
                                                                                                            : "border rounded-2 p-2 fw-bold mb-4 placeholder"
                                                                                                    }
                                                                                                >
                                                                                                    <span className="textTransform">
                                                                                                        {skill?.skill_name}
                                                                                                    </span>{" "}
                                                                                                    {skill?.skill_level
                                                                                                        ? "-"
                                                                                                        : null}{" "}
                                                                                                    <span className="fw-normal">
                                                                                                        {skill?.skill_level}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </React.Fragment>
                                                                                    );
                                                                                })
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {value.education.length === 0 ? null : (
                                                    <div className="col-lg-6 col-md-12">
                                                        <InfoAddCard
                                                            pageContentLoaded={pageContentLoaded}
                                                            cardHeadingIcon={
                                                                <FaGraduationCap
                                                                    className={
                                                                        pageContentLoaded
                                                                            ? "me-4 brand-color fs-4"
                                                                            : "me-4  fs-4 placeholder rounded-2"
                                                                    }
                                                                />
                                                            }
                                                            cardHeading="Education"
                                                            placeholder="Your education details will be displayed here"
                                                            arrayContent={value.education[0]}
                                                            currentPage="employerPool"
                                                            mobileScreen={mobileScreen}
                                                        />
                                                    </div>
                                                )}
                                                <hr
                                                    className={`mt-2`}
                                                />
                                            </div>

                                            <div className='w-100 d-flex flex-wrap mt-4 align-items-center'>
                                                <div className="col-8 profile-descriptions">
                                                    {
                                                        value?.applied_status === "applied" ?
                                                            <p className='text-secondary mb-0'>
                                                                <FiInfo size={19} />
                                                                <span className='ps-1'>The candidate you invited has applied for the job.</span>
                                                            </p>
                                                            :
                                                            null
                                                    }
                                                </div>
                                                <div className="col text-end">
                                                    <div id={`inviteToInterview${value.id}Button`}>
                                                        <button id={`${i === 0 ? "clickToSeeProfile2" : ""}`} className={pageContentLoaded ? "btn btn-brand-color pe-none opacity-75" : "btn  placeholder rounded-2"} >
                                                            Invited
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })
                        :
                        <div className="h-100">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="d-flex  justify-content-center vh-80 align-items-center">
                                    <img
                                        src={images.noRecordsFound}
                                        width={250}
                                        height={250}
                                    />
                                </div>
                            </div>
                        </div>
                }
            </div>

            <div className="scroll-to-top-icon"
                id="scroll-to-top-icon"
                onClick={scrollToTop}
                title="Scroll to top"
                style={{ display: isVisible ? "block" : "none" }}
            >
                <BsFillArrowUpCircleFill className="fs-1 brand-color" />
            </div>

            <div
                className="modal fade"
                id="fullProfileModal"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div
                        className={`modal-content ${mobileScreen ? "px-0 " : "px-3"} mx-2 `}
                    >
                        <div className="modal-header border-bottom-0 ">
                            <h1 className="modal-title fs-5 mt-2" id="staticBackdropLabel">
                                Applicant full profile
                            </h1>
                            <button
                                id="closeViewProfileButton"
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body border-bottom-0 ">
                            <div className="container px-0">
                                {professionalId !== null ? (
                                    <CandidateProfile
                                        professionalId={professionalId}
                                        mobileScreen={mobileScreen}
                                    />
                                ) : null}
                            </div>
                        </div>
                        <div className="modal-footer border-top-0">
                            <div className="container">
                                <div className="row float-end">
                                    <div className="col-lg-12 ">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            data-bs-dismiss="modal"
                                        >
                                            <span>Cancel</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvitedApplicants